import i18n from '@dms/i18n';

import {VEHICLE_FORM_EVENTS} from '../../core/machine/constants/VEHICLE_FORM_EVENTS';
import {RentalVehicle} from '../../core/types/RentalVehicle';
import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

/**
 * Date picker component for selecting the last service inspection date of a vehicle.
 * Used in service interval tracking to record when a service inspection was last performed.
 * Automatically calculates the next service inspection date when changed.
 */
export function LastServiceInspectionDatePicker() {
  const {sendMachineEvent} = useVehicleFormContext();

  const handleChange = (value: string | null) => {
    sendMachineEvent({
      type: VEHICLE_FORM_EVENTS.SERVICE_INSPECTIONS_DATE_CHANGED,
      value,
    });
  };

  return (
    <Field<RentalVehicle>
      type="apiDate"
      name="serviceIntervals.serviceInspection.lastServiceInspectionDate"
      label={i18n.t('entity.vehicle.labels.dateOfLastInspection')}
      onChange={handleChange}
    />
  );
}
